// extracted by mini-css-extract-plugin
export default {"apple":"ButonApple_apple__uZQsU","txtApple":"ButonApple_txtApple__Nm5BU"};